/* eslint-disable no-restricted-exports */
import { flare } from "@flareapp/js";
import { flareVue } from "@flareapp/vue";
import { redact } from "@smakecloud/browser-telemetry";

export default defineNuxtPlugin({
    name: "flare",
    setup(nuxtApp) {
        const { data: production } = storeToRefs(useUserStore());
        const { payload } = storeToRefs(useAuthStore());

        // ids only: no production name, no staff name or e-mail
        watchEffect(() => {
            flare.addContextGroup("Production", {
                id: production.value?.id ?? payload.value?.production_id,
            });

            flare.addContextGroup(
                "User",
                payload.value
                    ? { id: payload.value.staff_id }
                    : { name: "Not logged in" },
            );
        });

        flare.light(nuxtApp.$config.public.flareAppKey);

        flare.beforeSubmit = (report) => {
            if (nuxtApp.$config.public.appEnv === "local") {
                console.error(report);

                return false;
            }

            // same rules as Faro: login tokens (/entrance?t=…), secrets, e-mail addresses
            return redact(
                {
                    ...report,
                    application_path: report.context.request?.url,
                    context: {
                        ...report.context,
                        // Flare's own parse of the query ({ t, r } on /entrance) would bypass the
                        // URL rules; the query stays in context.request.url, redacted
                        request_data: undefined,
                    },
                },
                { maxDepth: 16 },
            );
        };

        nuxtApp.vueApp.use(flareVue);

        nuxtApp.hook("vue:error", async (error, _instance, info) => {
            const flareReportError = error as Error;

            flare.addContextGroup("Info", {
                additional_Info: info,
                title: flareReportError.message,
            });
            await flare.report(flareReportError);
        });
    },
});
